import React, { useEffect, useRef, useState } from 'react'
import { Radio } from 'antd'
import Icons from '../../../../assets/icons';
import ParentModal from '../../../../genericComponents/ParentModal';
import GenericMediaViewModal from '../../../../genericComponents/media/GenericMediaViewModal';
import { dispatchHandler } from '../../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import '../../../../styles/stylesheets/GenericComponents.scss'
import GenericCustomButton from '../../../../genericComponents/GenericCustomButton';
import LanguageTranslator from '../../../../locals/LanguageTranslator';
import { getPermissionKey } from '../../../../helper/permissions';
import { ChevronLeft, ChevronRight, Copy, Expand, Play, Plus, X } from 'lucide-react';
import GenericCopyComponent from '../../../../genericComponents/GenericCopyComponent';
import TextWithTooltip from '../../../../genericComponents/TextWithTooltip';
import CopyContentGenericComponent from '../../../../genericComponents/CopyContentGenericComponent';
import { getFileNameFromUrl } from '../../../../helper/genericFunction';

const ImageUpload = (props) => {

    const inputRef = useRef(null);
    const dispatch = useDispatch();

    const uploadUtilityDocumentData = useSelector(state => state?.digivendStore?.uploadUtilityDocumentData);

    const { mediaData = {}, setMediaData, heading='', showTabs=true } = props || {};

    const [selectedModal, setSelectedModal] = useState("");
    const [selectedData, setSelectedData] = useState({});

    const [showUploadError, setShowUploadError] = useState(false);
    const [currentFileIndex, setCurrentFileIndex] = useState(0)

    const {
        module = "product",
        viewOnly = true,
        formSettings,
        mandatoryKey,
        displayKey,
        isEditableKey,
        headerExtras=null
    } = props || {};

    const [currentType, setCurrentType] = useState("");

    const [currentMedia, setCurrentMedia] = useState("");

    const [options, setOptions] = useState({});

    const [updatedKey, setUpdatedKey] = useState("");

    let mediaOptions = {
        "product": {
            "allImages": {
                "imageUrlFront": {
                    type: "image",
                    label: "Front"
                },
                "imageUrlBack": {
                    type: "image",
                    label: "Back"
                },
                "imageUrlSide": {
                    type: "image",
                    label: "Side"
                },
                "imageUrlDetailed": {
                    type: "image",
                    label: "Detail"
                },
                "imageUrlLook": {
                    type: "image",
                    label: "Look"
                },
                "videoUrl": {
                    type: "video",
                    label: "Video"
                }
            },
            "rawImages": {
                "rawImage1": {
                    type: "image",
                    label: "Raw Image 1",
                },
                "rawImage2": {
                    type: "image",
                    label: "Raw Image 2"
                }
            },
            "document": {
                "teckPackUrl": {
                    type: "pdf",
                    label: "Tec Pack"
                },
                "pdfUrl": {
                    type: "pdf",
                    label: "PDF"
                }
            }
        },
        "fabric": {
            "fabric": {
                "fabricImage": {
                    type: "image",
                    label: "Fabric",
                }
            }
        }
    }


    useEffect(() => {
        if (uploadUtilityDocumentData?.isSuccess) {
            let updatedMediaData = { ...mediaData };
            if (uploadUtilityDocumentData?.data?.resource?.[0]) {
                updatedMediaData[updatedKey] = { ...uploadUtilityDocumentData?.data?.resource?.[0], "requestId": uploadUtilityDocumentData?.data?.requestId || "" } || {};
                let updatedErrorData = { ...props.mainErrorData };
                if (updatedErrorData?.[updatedKey]) {
                    delete updatedErrorData?.[updatedKey];
                }
                props.updateErrorData(updatedErrorData)
                setMediaData(updatedMediaData);

                if(updatedKey == "imageUrlFront" && props.customAction?.["callApiAfterImageUrlFrontUpload"]){
                    props.customAction?.["callApiAfterImageUrlFrontUpload"]?.(uploadUtilityDocumentData?.data?.resource?.[0]);
                }
            }
        };

        setUpdatedKey("");
    }, [uploadUtilityDocumentData?.isSuccess, uploadUtilityDocumentData?.isError])

    useEffect(() => {
        let updatedOptions = {};
        let obj = {
            "allImages": "All Images",
            "rawImages": "Raw Images",
            "document": "Document",
            "fabric": "Fabric",
        }

        Object.keys(mediaOptions?.[module] || {})?.map(mainKey => {
            if (Object.keys(mediaOptions?.[module]?.[mainKey])?.some(key => formSettings?.[key]?.[displayKey])) {
                updatedOptions[mainKey] = obj[mainKey]
            }
        })
        setOptions(updatedOptions)
        setCurrentType(Object?.keys(updatedOptions || {})?.[0] || "");
    }, [formSettings])

    useEffect(() => {
        setCurrentMedia(Object.keys(getUpdatedMediaOptions() || {})?.[0] || "");
        setCurrentFileIndex(0)
    }, [currentType])

    const handleChange = (key, data) => {
        switch (key) {
            case "viewImage": {
                setSelectedModal("viewImage");
                setSelectedData(data);
                break;
            }
            case "removeFile": {
                let updatedMedia = { ...mediaData };
                delete updatedMedia?.[data];
                setMediaData(updatedMedia);
                if (inputRef.current) {
                inputRef.current.value = '';
                }
                break;
            }
        }
    }

    const handlePagination = (type, data) => {
        switch (type) {
            case "prevImg": {
                if(currentFileIndex > 0) {
                    setCurrentFileIndex(prev => {
                        if (prev == 0) {
                            // console.log("current sdfasd",currentFileIndex, filesData);
                            // if (filesData?.length > 1) {
                            //     return filesData?.length - 1
                            // }
                        }
                        else {
                        return Number(prev) - 1;
                        }
                    })
                    const currentIndex = (Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key])))?.indexOf((currentMedia));
                    setCurrentMedia((Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key])))?.[currentIndex-1])
                }
            }
                break;
            case "nextImg": {
                if ((Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.length - 1) > currentFileIndex) {
                    setCurrentFileIndex(prev => {
                        if ((Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.length - 1) == prev) {
                            // if (filesData?.length > 1) {
                            //     return 0;
                            // }
                        }
                        else {
                        return Number(prev) + 1;
                        }
                    })
                    const currentIndex = (Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key])))?.indexOf((currentMedia));
                    setCurrentMedia((Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key])))?.[currentIndex+1])
                }
            }
                break;
            // case "imageClick": {
            //     setCurrentFileIndex(data)
            // }
                break;
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "viewImage": return GenericMediaViewModal;
        }
    }

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal(false); },
            animationType: "bottom",
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: "fixed", borderRadius: 4 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
			postitionProps: { position: 'relative' },
            dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
        }
        
        switch (selectedModal) { 
            case "viewImage": {

                console.log("Media data", mediaData);

                const filesData = Object.keys(mediaData || {})?.map(key => {
                    if(mediaData?.[key]?.["url"] && mediaOptions?.[module]?.[currentType]?.[key]) {

                        let modifiedFileUrl = mediaData?.[key]?.["url"]?.replace("disposition=attachment", "disposition=inline");

                        return {
                            fileUrl: modifiedFileUrl || "",
                            fileType: mediaOptions?.[module]?.[currentType]?.[key]?.["type"] || "",
                            fileName: mediaData?.[key]?.["fileName"] || ""
                        }
                    } else {
                        return null;
                    }
                })?.filter(item => Boolean(item))


                return {
                    ...payload,
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    filesData: filesData,
                    current : Object.keys(mediaData)?.filter(key => mediaOptions?.[module]?.[currentType]?.[key])?.findIndex(item  => item == currentMedia)
                }
            }
            default :return null;
        }
    }


    // Function  : To render the currentMedia
    const renderMedia = (type, key) => {
        let fileType = mediaOptions?.[module]?.[currentType]?.[key]?.["type"]

        console.log('mediaData?.[currentMedia]', mediaData)

        const renderPlaceholder = () => {
            switch (fileType) {
                case "video": {
                    return <>
                        {mediaData?.[key] ? <div className='relative h-full w-full'>
                            <video controls={false} width="100%" height="100%" className="videoPlayer !h-full !w-full object-cover object-center" preload="metadata">
                                <source src={mediaData?.[key]?.["url"]} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/75 backdrop-blur-sm ${type === "main" ? 'p-[12px] cursor-pointer hover:opacity-75' : 'p-[6px]'}`}><Play size={type === "main" ? 24 : 12} fill='black' color='black' /></div>
                        </div> :
                            type == "main" ? <div className='guii-no-img'>
                                <Icons.CatalogueImageThumbnail />
                                <p>No Video Uploaded</p>
                            </div> :
                                <div className='guii-normal-no-img'>
                                    <Plus color='#6A6C70' size={18} className='shrink-0' />
                                </div>
                        }
                    </>
                }
                case "pdf": {
                    return mediaData?.[key] ?
                        <div className='guii-no-img'>
                            {type == "main" && <Icons.PdfFileIcon2 width={50} height={65} />}
                            {
                                type === "main" ? 
                                <p className='mb-0 !mt-[8px]'>PDF Uploaded</p>
                                : <Icons.PdfFileIcon2 width={28} height={28} />
                            }
                        </div> :
                        type == "main" ? <div className='guii-no-img'>
                            <Icons.NoDocument />
                            <LanguageTranslator tag="p">No PDF Uploaded</LanguageTranslator>
                        </div> :  
                            <div className='guii-normal-no-img'>
                                <Plus color='#6A6C70' size={18} className='shrink-0' />
                            </div>
                }
                default: {
                    return mediaData?.[key] ? <img className='object-cover object-center' src={mediaData?.[key]?.["url"]} /> :
                        type == "main" ? <div className='guii-no-img'>
                            <Icons.CatalogueImageThumbnail />
                            <LanguageTranslator tag="p">No Image Uploaded</LanguageTranslator>
                        </div> :
                            <div className='guii-normal-no-img'>
                                <Plus color='#6A6C70' size={18} className='shrink-0' />
                            </div>
                }
            }
        }

        let acceptFiles = {
            "video": "video/*",
            "image": "image/*",
            "pdf": "application/pdf"
        }

        return <>
            {type === 'main' && <div className='px-2 py-1 bg-white/80 backdrop-blur-[8px] rounded-b-[4px] absolute z-[1] left-[1px] top-[1px] rounded-tl-[3px] rounded-bl-none rounded-br-[5px]'><LanguageTranslator tag="p" className='mb-0 text-[11px] font-medium text-fontBlack'><LanguageTranslator>{imageConfigurationCases("displayName", currentMedia) || ""}</LanguageTranslator> <span className='mandatory'>{imageConfigurationCases("mandatory", currentMedia) && "*"}</span></LanguageTranslator></div>}
            {type === 'main' && Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.length > 1 && <div className='absolute z-[1] left-[12px] top-1/2 -translate-y-1/2'><GenericCustomButton 
                leftIcon={<ChevronLeft size={12} color='#67768E'/>}
                className='p-[4px] h-[20px] aspect-square shrink-0 rounded-full bg-white/80 backdrop-blur-[8px] hover:brightness-75'
                onClick={(e)=>{e.stopPropagation(); handlePagination('prevImg')}}
                disabled={currentFileIndex === 0}
            /></div>}
            {type === 'main' && Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.length > 1 && <div className='absolute z-[1] right-[12px] top-1/2 -translate-y-1/2'>
                <GenericCustomButton 
                    leftIcon={<ChevronRight size={12} color='#67768E'/>}
                    className='p-[4px] h-[20px] aspect-square shrink-0 rounded-full bg-white/80 backdrop-blur-[8px] hover:brightness-75'
                    onClick={(e)=>{e.stopPropagation(); handlePagination('nextImg')}}
                    disabled={(Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.length - 1) === currentFileIndex}
                />
            </div>}
            {type != "main" &&
                <input
                    className={mediaData?.[key] && "!hidden"}
                    type="file"
                    autoComplete="off"
                    key={mediaData?.[key] ? 'has-file' : 'no-file'} 
                    disabled={viewOnly || mediaData?.[key] || imageConfigurationCases("disabled", key)}
                    style={{ position: "absolute", top: 0 }}
                    ref={inputRef} // Assign inputRef to the ref attribute
                    accept={acceptFiles?.[fileType]}
                    onChange={(e) => {
                        setUpdatedKey(key);

                        if (e?.target?.files?.[0]) {
                            let file = e?.target?.files?.[0]
                            console.log("File Changes", file?.size);
                            if (file?.size <= 100 * 1024 * 1024) {
                                const formData = new FormData();
                                formData?.append("file", e?.target?.files?.[0]);
                                formData?.append("type", "CATALOGUE_PRODUCT");
                                formData?.append("documentId", 0);
                                dispatchHandler(dispatch, "uploadUtilityDocumentRequest", formData, getPermissionKey("common", "commonFunctionality", "upload"));
                            } else {
                                setShowUploadError(true);
                                setTimeout(() => {
                                    setShowUploadError(false);
                                }, 5000)
                            }
                        }

                        if (inputRef?.current)
                            inputRef.current.value = ""; // Now inputRef is accessible
                    }}
                />}
            <div className={`guii-img w-full flex items-center justify-center ${type === 'normal' ? '!h-full' : '!h-[400px] border border-[#C7D3DF] rounded overflow-hidden'}`}>
                {renderPlaceholder()}
            </div>
        </>
    }

    const imageConfigurationCases = (key, mainKey) => {
        // console.log("ASdfsd",formSettings?.[mainKey]);
        if (formSettings?.[mainKey]) {
            switch (key) {
                case "mandatory": {
                    return formSettings?.[mainKey]?.[mandatoryKey] == 1;
                }
                case "display": {
                    return formSettings?.[mainKey]?.[displayKey] == 1;
                }
                case "disabled": {
                    return !formSettings?.[mainKey]?.[isEditableKey];
                }
                case "displayName": {
                    return formSettings?.[mainKey]?.["displayName"] || ""
                }
            }
        }
        return null;
    }
    const getUpdatedMediaOptions = () => {
        let mediaImageOption = {};
        Object.keys(mediaOptions?.[module]?.[currentType] || {})?.map(key => {
            console.log("asdfasdf", key, imageConfigurationCases("display", key))
            if (imageConfigurationCases("display", key)) {
                mediaImageOption[key] = mediaOptions?.[module]?.[currentType]?.[key];
            }
        })
        return mediaImageOption
    }

    console.log("Media data",getUpdatedMediaOptions(), currentType );



    const renderImageUploadError = () => {
        return Object.keys(mediaOptions?.[module] || {})?.some(mainKey => Object.keys(props.errorData?.[mainKey] || {})?.length > 0)  && <div className='gui-error'>
            {Object.keys(mediaOptions?.[module] || {})?.map(mainKey => Object.keys(props.errorData?.[mainKey] || {})?.length > 0 &&
                <div className='guie-sec'>
                    <h1>{options?.[mainKey] || ""} : </h1>
                    {Object.keys(props.errorData?.[mainKey] || {})?.map(key => {
                        console.log("asdfasf", key, formSettings);
                        return <li className='mx-4'>{props.errorData?.[mainKey]?.[key] || ""}</li>
                    })}
                </div>)
            }
        </div>
    }

    return (
        Object.keys(options)?.length > 0 && <div className={`generic-upload-img viewproductDetails ${viewOnly ? '!h-auto' : ''}`}>
            {/* Render the images section here */}

            {/* Render the errors here for image upload section */}
                {renderImageUploadError()}

            {headerExtras && !viewOnly && <div className='mb-2 flex items-center justify-between gap-3'>
                {!viewOnly && <LanguageTranslator tag="h4" className='mb-0'>{heading || 'Product Images & Documents'}</LanguageTranslator>}
                {typeof headerExtras === "function" ? headerExtras() : headerExtras}
            </div>}

            {showTabs && <Radio.Group onChange={(e) => setCurrentType(e?.target?.value || "")} value={currentType}>
                {
                    Object.keys(options || {})?.map(key => (
                        <Radio.Button value={key}><LanguageTranslator>{options?.[key]}</LanguageTranslator></Radio.Button>
                    ))
                }
            </Radio.Group>}

            {/* Render the image section here */}
            <div className='gu-img-sec rounded-b-[5px]'>
                <div className='gui-img relative w-full !h-[400px] overflow-hidden' onClick={() => mediaData?.[currentMedia] && handleChange("viewImage",)}>
                    {mediaData?.[currentMedia]?.url && <div className='guii-btns absolute z-[1] right-[12px] top-[12px]'>
                        {/* <GenericCustomButton
                            className='preview-img'
                            label="Preview"
                        /> */}
                        <GenericCustomButton
                            className='expand-img p-[4px] h-[30px] w-[30px] flex items-center justify-center rounded-[5px] bg-white hover:opacity-75'
                            leftIcon={<Expand size={15} color='black' />}
                        />
                    </div>}
                    {renderMedia("main", currentMedia)}

                    <div className='absolute left-0 right-0 bottom-0 z-[1] w-full'>
                        {(!viewOnly || Object.keys(getUpdatedMediaOptions() || {})?.some(key => mediaData?.[key])) && <div style={{backgroundColor: 'transparent'}} className='gui-sub-img !px-3 !py-2 mb-4 scrollbar-thin-dark gap-4'>
                            {Object.keys(getUpdatedMediaOptions() || {})?.filter(key => (!viewOnly || mediaData?.[key]))?.map((key, index) => {
                                return (
                                <div className={`guis !p-[0] relative group`}>
                                    {!viewOnly && !imageConfigurationCases("disabled", key) && mediaData?.[key] && <LanguageTranslator tag="div" className='p-[1px] w-[16px] h-[16px] shrink-0 aspect-square flex items-center justify-center rounded-full bg-white absolute z-[1] top-[-6px] right-[-6px] cursor-pointer invisible opacity-0 pointer-events-none group-hover:visible group-hover:opacity-100 group-hover:pointer-events-auto hover:brightness-75' style={{boxShadow: '0px 0px 2px 0px #00000040'}} onClick={(e) => {e.stopPropagation(); handleChange("removeFile", key) }}><X size={12} /></LanguageTranslator>}
                                    {/* {(viewOnly || imageConfigurationCases("disabled", key) || !mediaData?.[key]) && <LanguageTranslator tag="p"><LanguageTranslator>{imageConfigurationCases("displayName", key) || ""}</LanguageTranslator> <span>{imageConfigurationCases("mandatory", key) && "*"}</span></LanguageTranslator>} */}
                                    <button className={`!bg-white ${mediaData?.[key] ? 'hover:!border-[5px] hover:border-white hover:!shadow-[0px_0px_4px_4px_#07070726]' : ''} ${currentFileIndex === index ? '!border-[5px] border-white !shadow-[0px_0px_4px_4px_#07070726]' : ''} ${imageConfigurationCases("disabled", key) && !viewOnly && "guis-btn-disable"}`} onClick={(e) => {e.stopPropagation(); setCurrentFileIndex(index); setCurrentMedia(key)}}>
                                        {renderMedia("normal", key)}
                                    </button>
                                </div>
                            )})}
                        </div>}

                        {mediaData?.[currentMedia]?.["url"] && <div className='px-4 py-2 bg-white/80 backdrop-blur-[8px] rounded-b-[4px] w-full flex items-center justify-center gap-2'>
                                <TextWithTooltip 
                                    as='a'
                                    width={250} 
                                    text={getFileNameFromUrl(mediaData?.[currentMedia]?.["url"]) || '-'} 
                                    href={mediaData?.[currentMedia]?.["url"]?.replace('disposition=attachment', 'disposition=inline')} 
                                    target='_blank' 
                                    rel="noopener noreferrer"   
                                    className='text-[11px] font-medium text-fontBlack underline max-w-[250px] hover:text-[#5d5fef]'
                                    onClick={e=>e.stopPropagation()}
                                />
                                {/* <CopyContentGenericComponent
                                    type={2}
                                    iconColor='black'
                                    content={mediaData?.[currentMedia]?.["url"]?.replace('disposition=attachment', 'disposition=inline')}
                                /> */}
                        </div>}
                    </div>
                </div>
                {/* Render the error to show the size limit has been exceeded */}
                {
                    showUploadError && <LanguageTranslator tag="p" style={{ color: "red" }}>File Size should be less than 100MB.</LanguageTranslator>
                }
            </div>


            {selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false); }}
            />}

        </div>
    )
}

export default ImageUpload